import { Address, Room } from '../stores/AddressStore';

export const resolveAddressCode = (address: Address, room: Room): string => {
  if (room && room.roomId) {
    return `${room.roomId}|R`;
  }
  if (address.buildingId) {
    return `${address.buildingId}|B`;
  }
  return `${address.id}|A`;
};
